import React from "react";
import { TableCell, TableRow } from "../../../../../components/ui/common/table";
import { cn } from "../../../../../lib/utils";
import { UNIT_LABEL_MAP } from "../../shared/constants/measurementUnits.constants";
import RowActions from "../../shared/components/RowActions";
import { resolveFacilityName, resolveProcessTypeName } from "../utils/processRecords.utils";
import { ApiProcessingRecord, ProcessRecordLookups } from "../types/processRecords.types";
import ExpandChevron from "./ExpandChevron";
import NumericCell from "./NumericCell";

interface ProcessReadRowProps {
  process: ApiProcessingRecord;
  expanded: boolean;
  lookups: ProcessRecordLookups;
  onToggleExpand: () => void;
  onEdit: () => void;
  disabled?: boolean;
}

/** Read-only process row. The whole row toggles expansion; the Actions cell does not. */
const ProcessReadRow: React.FC<ProcessReadRowProps> = ({
  process,
  expanded,
  lookups,
  onToggleExpand,
  onEdit,
  disabled = false
}) => (
  <TableRow
    className={cn("tw-cursor-pointer", expanded && "tw-bg-accent/30")}
    onClick={onToggleExpand}
  >
    <TableCell className="tw-p-0 tw-text-center">
      <ExpandChevron expanded={expanded} />
    </TableCell>
    <TableCell>
      <span className="tw-font-medium">{process.processingName || "—"}</span>
    </TableCell>
    <TableCell>
      <span>{resolveProcessTypeName(lookups.processTypeNameMap, process.processingType)}</span>
    </TableCell>
    <TableCell>
      <span>{resolveFacilityName(process.facilityId, lookups.facilityNameMap)}</span>
    </TableCell>
    <TableCell className="tw-text-right">
      <NumericCell value={process.capacity} unit={UNIT_LABEL_MAP[process.capacityUnit] ?? ""} />
    </TableCell>
    <TableCell className="tw-text-right">
      <NumericCell value={process.input} unit={UNIT_LABEL_MAP[process.inputUnit] ?? ""} />
    </TableCell>
    <TableCell className="tw-text-right">
      <NumericCell value={process.output} unit={UNIT_LABEL_MAP[process.outputUnit] ?? ""} />
    </TableCell>
    <TableCell className="tw-text-right">
      <NumericCell value={process.sideStream} unit={UNIT_LABEL_MAP[process.sideStreamUnit] ?? ""} />
    </TableCell>
    <TableCell className="tw-text-right">
      <NumericCell value={process.electricity} unit={UNIT_LABEL_MAP[process.electricityUnit] ?? ""} />
    </TableCell>
    <TableCell className="tw-text-right">
      <NumericCell value={process.water} unit={UNIT_LABEL_MAP[process.waterUnit] ?? ""} />
    </TableCell>
    <TableCell className="tw-text-right">
      <NumericCell value={process.heat} unit={UNIT_LABEL_MAP[process.heatUnit] ?? ""} />
    </TableCell>
    <TableCell className="tw-text-right" onClick={e => e.stopPropagation()}>
      <RowActions
        editing={false}
        onEdit={onEdit}
        onSave={() => undefined}
        onCancel={() => undefined}
        buttonClassName="tw-h-7 tw-w-7"
        disabled={disabled}
      />
    </TableCell>
  </TableRow>
);

export default ProcessReadRow;
